export const OrderType = {
    ONGOING:1,
    COMPLETED:2,
    CANCELLED:3
}

export const ORDER_STATUS ={
    ORDER_PLACED:1,
    IN_PROGRESS:2,
    SHIPPING:4,
    DELIVERED:4
}